module.exports = __webpack_public_path__ + "static/media/portillos.417a727d.png";